/* eslint-disable spaced-comment,func-names,object-shorthand */
import React from 'react';
import request from 'superagent';
import Highcharts from 'highcharts';
import Highstock from 'highcharts/highstock';
import Chart from "../../Chart";
import API from '../../../../config/API';
import {getDataFilesCacheVersion} from "../../../../helpers/cache";

require('highcharts-more')(Highstock);
require('highcharts/modules/exporting')(Highstock);
require('highcharts/modules/export-data.src')(Highstock);
const ReactHighcharts = require('react-highcharts/ReactHighstock').withHighcharts(Highstock);

class HYTradeVolume extends Chart {

    componentDidMount() {
        request.get(API.getHost('data').concat(getDataFilesCacheVersion('/data-feeds/charts/MarketInsights/abs_volume_count_by_size_hy.csv'))).then(data => {
            const options = {
                //set chart type
                chart: {
                    type: 'column',
                    renderTo: 'by_size_abs_volume_hy_container',
                    alignTicks: false,
                    height: 600,
                    style: {
                        fontFamily: 'Exo'
                    }
                },
                //set title
                title: {
                    text: 'TRACE High Yield Trade Volume',
                    style: {
                        color: '#4D759E'
                    },
                    align: 'center'
                },
                //set x-axis
                xAxis: {
                    title: {
                        text: 'Date',
                        style: {
                            color: '#4D759E',
                            fontWeight: 'bold'
                        }
                    },
                    gridLineWidth: 1,
                    //set datetime for x-axis with dates
                    type: 'datetime',
                    //make date labels vertical
                    labels: {
                        rotation: -90,
                        align: 'right',
                        y: 11
                    }
                },
                //set y-axis
                yAxis: {
                    title: {
                        text: 'TRACE High Yield Trade Volume ( Billions USD )',
                        style: {
                            color: '#4D759E',
                            fontWeight: 'bold'
                        }
                    },
                    labels: {
                        //format y-axis label with thousands place seperator
                        formatter: function() {
                            return Highcharts.numberFormat(this.value, 0, '', ',')
                        }
                    },
                    //keep stacks in order of series
                    reversedStacks: false,
                    //set y-axis to the left side
                    opposite: false
                },
                //set the starting range. 0-5. 5="All", 4="1yr", etc
                rangeSelector: {
                    selected: 4,
                    allButtonsEnabled: true
                },
                //set tooltip
                tooltip: {
                    valueDecimals: 0,
                    pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}</b><br/>'
                },
                //set legend
                legend: {
                    enabled: true,
                    layout: 'horizontal',
                    align: 'center',
                    borderWidth: 1,
                    borderRadius: 5
                },
                //set colors for series
                colors: [
                    '#1D5B7F',
                    '#76b34d',
                    '#636569',
                    '#6786B8',
                    '#8244FF',
                    '#848486',
                    '#a42a47',
                    '#f8dc32',
                    '#2a84b9',
                    '#91c271',
                    '#818388',
                    '#8598c6',
                    '#cd3d60',
                    '#f6e35b',
                    '#11374c',
                    '#476c2e',
                    '#3b3d3f',
                    '#374f75',
                    '#621903',
                    '#ad9506'
                ],
                //set general plot options
                plotOptions: {
                    column: {
                        pointPadding: 0,
                        borderWidth: 0,
                        stacking: 'normal'
                    }
                },
                //make download as csv format correctly
                navigator: {
                    series: {
                        includeInCSVExport: false
                    }
                },
                //instantiate series
                series: [],
                //set name of chart downloads
                exporting: {
                    filename: 'MarketAxess_by_size_abs_volume_hy',
                    //enable download icon
                    enabled: true,
                    //change chart options for download
                    chartOptions: {
                        //add image to download
                        chart: {
                            events: {
                                load: function() {
                                    this.renderer.image('/public/images/charts/marketaxess_logo2.gif', 90, 75, 300, 48).attr({
                                        opacity: 0.1
                                    }).add();
                                }
                            },
                        },
                        //remove scrollbar and navigator from downloaded image
                        scrollbar: {
                            enabled: false
                        },
                        navigator:{
                            enabled: false
                        }
                    },
                    //make download as csv format correctly
                    csv: {
                        dateFormat: '%Y-%m-%d'
                    }
                },
                //disable credits
                credits: {
                    enabled: false
                }
            };
            //names of labels in order of series. make sure they are the same as series header in data file
            const names = ['&lt; $100K','$100K - &lt; $1MM', '$1MM - $5MM', '$5MM+ (Using Avg. Capped Amt.)'];
            //get csv file, multiply by 100 (divide by .01) and populate chart
            this.readCSV(options, data.text, 1000000000, names);

            this.setState({options});
        });
    }

    render() {
        if (!this.state.options) return null;

        return(
            <div className="container">
                <ReactHighcharts config={this.state.options}/>
            </div>
        );
    }
}

export default HYTradeVolume;



// WEBPACK FOOTER //
// ./frontend/components/Charts/MarketInsights/HYTradingActivity/HYTradeVolume.jsx